import { render, staticRenderFns } from "./EditDepartmentStudents.vue?vue&type=template&id=5b701eb8"
import script from "./EditDepartmentStudents.vue?vue&type=script&lang=js"
export * from "./EditDepartmentStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports